<template>
    <NuxtLoadingIndicator :color="webshopSettings()?.hasPrimaryColor ? webshopSettings().global.primaryColor : '#E06633'" />
    <div
        class="space-y-4"
        :class="shouldShowCart ? 'pb-16 lg:pb-0' : ''"
    >
        <div class="flex flex-col">
            <NavBar />
            <NuxtLayout>
                <NuxtPage />
                <Footer />
            </NuxtLayout>
            <ModalsContainer />
            <transition
                name="slide-up-delay" mode="out-in"
            >
                <CartMobileButton
                    v-if="shouldShowCart"
                />
            </transition>
        </div>
    </div>
</template>

<script setup lang="ts">
    import { changeLocale } from '@formkit/vue'
    import { ModalsContainer } from 'vue-final-modal'
    import CartMobileButton from '~/components/Cart/CartMobileButton.vue'
    import Footer from '~/components/Footer.vue'
    import NavBar from '~/components/NavBar/NavBar.vue'
    import { account } from '~/store/account'
    import { cart } from '~/store/cart'
    import { checkout } from '~/store/checkout'
    import { shop } from '~/store/shop'
    import { webshopSettings } from '~/store/webshopSettings'
    import { setPostHogCompany, setPostHogUser } from '~/utils/event-tracker'
    import { isMenuPath } from '~/utils/path-utils'
    const { locale } = useI18n()
    const route = useRoute()
    const isMounted = ref(false)
    const i18nHead = useLocaleHead({
        addSeoAttributes: {
            canonicalQueries: [ 'foo' ]
        }
    })
    useHead({
        htmlAttrs: {
            lang: i18nHead.value.htmlAttrs!.lang
        },
        titleTemplate: titleChunk => {
            const title = webshopSettings()?.getSeoTitle || 'Foodticket Webshop'
            return titleChunk ? `${title} | ${titleChunk}` : title
        },
        meta: [
            {
                name: 'description',
                content: webshopSettings()?.global?.seoDescription || 'Foodticket Webshop Description'
            }
        ],
        style: [
            {
                innerHTML: webshopSettings().primaryColorCssVariable
            }
        ]
    })
    function setInitialTracking () {
        window.addEventListener('PostHogLoaded', () => {
            setPostHogCompany(webshopSettings()?.global?.client?.uuid || '0')
            if (account().uuid) {
                setPostHogUser(account().uuid)
            }
        })
    }
    onMounted(async () => {
        setInitialTracking()
        changeLocale(locale.value)
        isMounted.value = true
        checkout().resetDefaultDispatchType()
        checkout().resetPaymentMethod()
        await account().getUserData()
        await checkout().fetchCountries()
        await showGlobalAgeCheckModal(route.fullPath)
        await nextTick(async () => {
            await shop().getDeliveryMenu()
            await shop().getPickupMenu()
        })
    })
    const shouldShowCart = computed(() => isMounted.value === true && (isMenuPath(route.fullPath) || cart().hasCartProducts))
</script>
